import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Pedir el cierre de sesión desde fuera de la barra superior.
 *
 * <p>Cerrar sesión no es solo `AuthService.logout()`: la barra superior revisa antes los cambios sin sincronizar del
 * expediente, avisa si la tablet queda sin mecánico y limpia los contadores. Ese camino vive en un solo lugar; el
 * «Más» de la barra inferior del panel lo pide por acá en vez de copiarlo.
 */
@Injectable({ providedIn: 'root' })
export class CierreSesionService {
  private readonly pedidos = new Subject<void>();
  readonly pedido$ = this.pedidos.asObservable();

  pedir(): void {
    this.pedidos.next();
  }
}
